import { useQuery } from '@tanstack/react-query';

interface TokenResponse {
  token: string;
  expiresAt: string;
}

// 14 minutes — token lives 15, refresh just before expiry.
const REFRESH_AFTER_MS = 14 * 60 * 1000;

async function fetchToken(): Promise<TokenResponse> {
  const res = await fetch('/api/auth/token', { credentials: 'include' });
  if (!res.ok) throw new Error(`Token request failed: ${res.status}`);
  const json: { data?: TokenResponse; error?: string } = await res.json();
  if (!json.data) throw new Error(json.error ?? 'Malformed token response');
  return json.data;
}

export function useApiToken() {
  return useQuery({
    queryKey: ['api-token'],
    queryFn: fetchToken,
    staleTime: REFRESH_AFTER_MS,
    gcTime: REFRESH_AFTER_MS + 60_000,
    refetchOnWindowFocus: false,
    retry: 1,
  });
}
